<template>
    <div class="title">
        <span class="title-text">{{title}}</span>
    </div>
</template>

<script>
    export default {
        name: 'BaseTitleCenter',
        props: {
            title: String
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @rem: 37.5rem;
    @media screen and (min-width: 801px) {
        .title {
            font-size: 38px;
            text-align: center;
            font-weight: normal;
            .title-text {
                display: inline-block;
                padding:0 30px 10px;
                color: #333;
                border-bottom: 2px #333 solid;
            }
        }        
    }

    @media screen and (max-width: 800px) {
        .title {
            font-weight: bold;
            text-align: center;
            font-weight: bold;
            font-size: 14/@rem;
            .title-text {
                font-size: 14/@rem;
                display: inline-block;
                padding-bottom: 5/@rem;
                border-bottom: 1px #333 solid;
            }            
        }
    }
</style>